<template>
  <div class="wrapper">
    <div v-if="checked" class="checked">
      <ts-icon icon="check" size="xx-small" color="#000000" />
    </div>
    <div v-if="!checked" class="not-checked"></div>
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  width: 22px;
  height: 22px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.checked {
  width: 22px;
  height: 22px;

  border: solid 2px rgba(255, 255, 255, 0.32);
  background-blend-mode: normal, soft-light, normal;
  background-image: linear-gradient(to bottom, #99ffd1, #99ffd1), linear-gradient(281deg, #000000 100%, #ffffff 0%),
    linear-gradient(to bottom, #ebecf0, #ebecf0);
  box-sizing: border-box;
  background-color: #99ffd1;

  border-radius: 16px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.not-checked {
  width: 12px;
  height: 12px;
  border-radius: 12px;

  box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
  background-blend-mode: normal, soft-light, normal;
  background-clip: border-box;
  background-image: linear-gradient(to bottom, #ff9a8f, #ff9a8f), linear-gradient(318deg, #000000, #ffffff -5%),
    linear-gradient(to bottom, #ebecf0, #ebecf0);
}
</style>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  }
};
</script>
